import { render } from "./FilterBox.vue?vue&type=template&id=b03582b6&scoped=true"
import script from "./FilterBox.vue?vue&type=script&lang=js"
export * from "./FilterBox.vue?vue&type=script&lang=js"

import "./FilterBox.vue?vue&type=style&index=0&id=b03582b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b03582b6"]])

export default __exports__